import styled from 'styled-components';
import { Flex } from 'UI';

export const SViewToggleWrapper = styled.div`
  .ant5-segmented {
    background-color: ${({ theme }) => theme.color.grey85};

    .ant5-segmented-item-selected {
      background-color: ${({ theme }) => theme.color.white};
    }
  }
`;

export const SViewHeader = styled(Flex)`
  width: 100%;
  min-height: 60px;
  margin: 10px 0;
  background-color: ${({ theme }) => theme.color.brand_black};
  border-radius: 6px;
  padding: 10px 15px;
`;
